/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import useMediaQuery, { MOBILE_WIDTH_QUERY } from '../hooks/useMediaQuery';
import closeIcon from '../../assets/images/close.svg';
import warningIcon from '../../assets/images/warning-banner-icon.svg';

import './MultiDateSelector.scss';

const MultiDateSelector = ({
	onApply,
	onClose,
	minDate = new Date(),
	maxDate,
	maxDatesCountLimit = 3,
	maxAvailableDates,
	selectedDates
}) => {
	const isMobile = useMediaQuery(MOBILE_WIDTH_QUERY);

	const _maxDate = maxDate || new Date(minDate.getFullYear() + 2, minDate.getMonth(), minDate.getDate());

	const [localDates, setLocalDates] = useState([]);
	const [hasChanges, setHasChanges] = useState(false);

	useEffect(() => {
		if (selectedDates) {
			const dates = selectedDates.map((d) => (d instanceof Date ? d : moment(d, 'YYYY-MM-DD').toDate()));
			setLocalDates(dates);
		}
	}, []);

	const hideModal = () => {
		setLocalDates([]);
		onClose();
	};

	const isError = localDates.length >= maxAvailableDates;

	const handleClear = () => {
		setLocalDates([]);
		setHasChanges(true);
	};
	const onDateChange = (event) => {
		if (localDates.length < maxAvailableDates || localDates.length > event.value.length) {
			setLocalDates(event.value);
			setHasChanges(true);
		}
	};
	const handleApply = () => onApply(localDates);

	return (
		<Dialog
			visible
			className="multi-date-selector"
			onHide={hideModal}
			headerStyle={{ display: 'none' }}
			resizable={false}
			closeOnEscape={false}
		>
			<div className="header">
				<div className="title">Select dates</div>
				<img src={closeIcon} alt="close" onClick={hideModal} className="close-icon" />
			</div>
			<Calendar
				value={localDates}
				onChange={onDateChange}
				selectionMode="multiple"
				showOtherMonths={false}
				numberOfMonths={isMobile ? 1 : 2}
				minDate={minDate}
				maxDate={_maxDate}
				readOnlyInput
				inline
			/>
			{isError && (
				<div className="error-banner">
					<img src={warningIcon} alt="error" />
					<div>{`You've selected a max of ${maxDatesCountLimit} dates, remove dates from any shift to add more here`}</div>
				</div>
			)}

			<div className="multi-date-actions">
				<div className="multi-date-actions__text">{`${localDates.length} date${
					localDates.length !== 1 ? 's' : ''
				} selected`}</div>
				<div className="multi-date-actions__buttons">
					<button type="button" className="button button-secondary" onClick={handleClear}>
						Clear
					</button>
					<button type="button" className="button button-primary" onClick={handleApply} disabled={!hasChanges}>
						Done
					</button>
				</div>
			</div>
		</Dialog>
	);
};

export default MultiDateSelector;
